"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoalkeeperRoleBonuses = exports.GoalkeeperExpandedRoles = void 0;
// goalkeeperRoles.ts
const playerBonuses_1 = require("../playerBonuses"); // Ensure this path is correct
const playerTraits_1 = require("../playerTraits");
const rarity_1 = require("../rarity");
const zones_1 = require("../zones");
const baseRoles_1 = require("./baseRoles");
var GoalkeeperExpandedRoles;
(function (GoalkeeperExpandedRoles) {
    // --- Uncommon --- GENERIC (Consistent where applicable)
    GoalkeeperExpandedRoles["DETERMINED_GOALKEEPER"] = "DETERMINED_GOALKEEPER";
    GoalkeeperExpandedRoles["HEROIC_GOALKEEPER"] = "HEROIC_GOALKEEPER";
    GoalkeeperExpandedRoles["ECCENTRIC_GOALKEEPER"] = "ECCENTRIC_GOALKEEPER";
    GoalkeeperExpandedRoles["RELIABLE_GOALKEEPER"] = "RELIABLE_GOALKEEPER";
    GoalkeeperExpandedRoles["LUCKY_GOALKEEPER"] = "LUCKY_GOALKEEPER";
    GoalkeeperExpandedRoles["TENACIOUS_GOALKEEPER"] = "TENACIOUS_GOALKEEPER";
    GoalkeeperExpandedRoles["INSPIRATIONAL_GOALKEEPER"] = "INSPIRATIONAL_GOALKEEPER";
    GoalkeeperExpandedRoles["DOMINANT_GOALKEEPER"] = "DOMINANT_GOALKEEPER";
    GoalkeeperExpandedRoles["IMPACT_GOALKEEPER"] = "IMPACT_GOALKEEPER";
    GoalkeeperExpandedRoles["STUBBORN_GOALKEEPER"] = "STUBBORN_GOALKEEPER";
    GoalkeeperExpandedRoles["ORGANISED_GOALKEEPER"] = "ORGANISED_GOALKEEPER";
    GoalkeeperExpandedRoles["NO_NONSENSE_GOALKEEPER"] = "NO_NONSENSE_GOALKEEPER";
    // --- Uncommon --- GK SPECIFIC / FUNCTIONAL
    GoalkeeperExpandedRoles["BALL_PLAYING_GOALKEEPER"] = "BALL_PLAYING_GOALKEEPER";
    GoalkeeperExpandedRoles["SWEEPER_KEEPER"] = "SWEEPER_KEEPER";
    // --- Rare Roles (Combining two Uncommons) ---
    GoalkeeperExpandedRoles["COMPLETE_GOALKEEPER"] = "COMPLETE_GOALKEEPER";
    GoalkeeperExpandedRoles["PLUCKY_GOALKEEPER"] = "PLUCKY_GOALKEEPER";
    GoalkeeperExpandedRoles["VALIANT_GOALKEEPER"] = "VALIANT_GOALKEEPER";
    GoalkeeperExpandedRoles["IMPOSING_GOALKEEPER"] = "IMPOSING_GOALKEEPER";
    GoalkeeperExpandedRoles["WALL"] = "WALL";
    GoalkeeperExpandedRoles["ROUSING_GOALKEEPER"] = "ROUSING_GOALKEEPER";
    // JAMMY_KEEPER removed as duplicate of PLUCKY_GOALKEEPER
    GoalkeeperExpandedRoles["COMMANDING_KEEPER"] = "COMMANDING_KEEPER";
    GoalkeeperExpandedRoles["PLAYMAKING_GOALKEEPER"] = "PLAYMAKING_GOALKEEPER";
    GoalkeeperExpandedRoles["MODERN_GOALKEEPER"] = "MODERN_GOALKEEPER";
})(GoalkeeperExpandedRoles || (exports.GoalkeeperExpandedRoles = GoalkeeperExpandedRoles = {}));
exports.GoalkeeperRoleBonuses = {
    [baseRoles_1.BaseRoles.GOAL_KEEPER]: {
        // Second stat should be intercepting, but we don't want to introduce it until GK can intercept (introduced with sweeper trait)
        statBlock: { block: playerBonuses_1.PlayerBonuses.MAIN_POSITION_ATTRIBUTE, pass: playerBonuses_1.PlayerBonuses.THIRD_POSITION_ATTRIBUTE },
        positionsEnabled: [zones_1.Zones.DEFENSE],
        playerTraits: [playerTraits_1.PlayerTraits.GOAL_KEEPER], // Base GK has the core GK trait
        rarity: rarity_1.Rarity.COMMON,
    },
    // --- Uncommon --- GENERIC ---
    [GoalkeeperExpandedRoles.DETERMINED_GOALKEEPER]: {
        parentRoles: [baseRoles_1.BaseRoles.GOAL_KEEPER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.DETERMINED],
    },
    [GoalkeeperExpandedRoles.HEROIC_GOALKEEPER]: {
        parentRoles: [baseRoles_1.BaseRoles.GOAL_KEEPER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.HERO],
    },
    [GoalkeeperExpandedRoles.ECCENTRIC_GOALKEEPER]: {
        parentRoles: [baseRoles_1.BaseRoles.GOAL_KEEPER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Eccentric runs/actions (Adds run stat)
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.FLAIR],
    },
    [GoalkeeperExpandedRoles.RELIABLE_GOALKEEPER]: {
        parentRoles: [baseRoles_1.BaseRoles.GOAL_KEEPER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Reliability in saves
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.RELIABLE],
    },
    [GoalkeeperExpandedRoles.LUCKY_GOALKEEPER]: {
        parentRoles: [baseRoles_1.BaseRoles.GOAL_KEEPER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Lucky saves
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.LUCKY],
    },
    [GoalkeeperExpandedRoles.TENACIOUS_GOALKEEPER]: {
        parentRoles: [baseRoles_1.BaseRoles.GOAL_KEEPER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Tenacious effort in saving
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.UNDERDOG],
    },
    [GoalkeeperExpandedRoles.INSPIRATIONAL_GOALKEEPER]: {
        parentRoles: [baseRoles_1.BaseRoles.GOAL_KEEPER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Inspiring presence/saves
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.INSPIRE],
    },
    [GoalkeeperExpandedRoles.DOMINANT_GOALKEEPER]: {
        parentRoles: [baseRoles_1.BaseRoles.GOAL_KEEPER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Dominance in the box/saves
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.DOMINANT],
    },
    [GoalkeeperExpandedRoles.IMPACT_GOALKEEPER]: {
        parentRoles: [baseRoles_1.BaseRoles.GOAL_KEEPER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Key saves when coming on
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.SUPER_SUB],
    },
    [GoalkeeperExpandedRoles.STUBBORN_GOALKEEPER]: {
        parentRoles: [baseRoles_1.BaseRoles.GOAL_KEEPER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.UNYIELDING],
    },
    [GoalkeeperExpandedRoles.ORGANISED_GOALKEEPER]: {
        parentRoles: [baseRoles_1.BaseRoles.GOAL_KEEPER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Organisation improving defensive setup/saves
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.ORGANISED],
    },
    [GoalkeeperExpandedRoles.NO_NONSENSE_GOALKEEPER]: {
        parentRoles: [baseRoles_1.BaseRoles.GOAL_KEEPER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Bonus to distribution (adds pass stat)
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.LONG_BALL],
    },
    // --- Uncommon --- GK SPECIFIC / FUNCTIONAL ---
    [GoalkeeperExpandedRoles.BALL_PLAYING_GOALKEEPER]: {
        parentRoles: [baseRoles_1.BaseRoles.GOAL_KEEPER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Adds pass stat
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.SECURE_POSSESSION],
    },
    [GoalkeeperExpandedRoles.SWEEPER_KEEPER]: {
        parentRoles: [baseRoles_1.BaseRoles.GOAL_KEEPER], rarity: rarity_1.Rarity.UNCOMMON,
        // Unorthodox, but it's because keeper should have intercept as second attribute, but base GK can't intercept
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE + playerBonuses_1.PlayerBonuses.SECOND_POSITION_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.SWEEPER],
    },
    // --- Rare Roles ---
    [GoalkeeperExpandedRoles.COMPLETE_GOALKEEPER]: {
        parentRoles: [GoalkeeperExpandedRoles.BALL_PLAYING_GOALKEEPER, GoalkeeperExpandedRoles.SWEEPER_KEEPER],
        rarity: rarity_1.Rarity.RARE, statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Well-rounded, focus on saves
        positionsEnabled: [], playerTraits: [],
    },
    [GoalkeeperExpandedRoles.PLUCKY_GOALKEEPER]: {
        parentRoles: [GoalkeeperExpandedRoles.TENACIOUS_GOALKEEPER, GoalkeeperExpandedRoles.LUCKY_GOALKEEPER],
        rarity: rarity_1.Rarity.RARE, statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [],
    },
    [GoalkeeperExpandedRoles.VALIANT_GOALKEEPER]: {
        parentRoles: [GoalkeeperExpandedRoles.HEROIC_GOALKEEPER, GoalkeeperExpandedRoles.DETERMINED_GOALKEEPER],
        rarity: rarity_1.Rarity.RARE, statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [],
    },
    [GoalkeeperExpandedRoles.IMPOSING_GOALKEEPER]: {
        parentRoles: [GoalkeeperExpandedRoles.DOMINANT_GOALKEEPER, GoalkeeperExpandedRoles.STUBBORN_GOALKEEPER],
        rarity: rarity_1.Rarity.RARE, statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [],
    },
    [GoalkeeperExpandedRoles.WALL]: {
        parentRoles: [GoalkeeperExpandedRoles.STUBBORN_GOALKEEPER, GoalkeeperExpandedRoles.RELIABLE_GOALKEEPER],
        rarity: rarity_1.Rarity.RARE, statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [],
    },
    [GoalkeeperExpandedRoles.ROUSING_GOALKEEPER]: {
        parentRoles: [GoalkeeperExpandedRoles.INSPIRATIONAL_GOALKEEPER, GoalkeeperExpandedRoles.DETERMINED_GOALKEEPER],
        rarity: rarity_1.Rarity.RARE, statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [],
    },
    [GoalkeeperExpandedRoles.COMMANDING_KEEPER]: {
        parentRoles: [GoalkeeperExpandedRoles.ORGANISED_GOALKEEPER, GoalkeeperExpandedRoles.INSPIRATIONAL_GOALKEEPER],
        rarity: rarity_1.Rarity.RARE, statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Command improves defensive outcomes
        positionsEnabled: [], playerTraits: [],
    },
    [GoalkeeperExpandedRoles.PLAYMAKING_GOALKEEPER]: {
        parentRoles: [GoalkeeperExpandedRoles.BALL_PLAYING_GOALKEEPER, GoalkeeperExpandedRoles.NO_NONSENSE_GOALKEEPER],
        rarity: rarity_1.Rarity.RARE, statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Focus on distribution range/quality
        positionsEnabled: [], playerTraits: [],
    },
    [GoalkeeperExpandedRoles.MODERN_GOALKEEPER]: {
        parentRoles: [GoalkeeperExpandedRoles.BALL_PLAYING_GOALKEEPER, GoalkeeperExpandedRoles.ORGANISED_GOALKEEPER],
        rarity: rarity_1.Rarity.RARE, statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Blend of distribution and organisation
        positionsEnabled: [], playerTraits: [],
    },
};
